// @ts-strict-ignore
import { BlockType, PageContentBlock } from 'api/cms';

const blocksWithBackground: BlockType[] = [
  'FLASH_CARD_QUIZ',
  'TWO_TILES',
  'RANDOM_GRAD_PROGRAMS',
  'RECOMMENDED_ACTIONS',
];

type Props = {
  block: PageContentBlock;
  fullWidthLayout?: boolean;
};

export function getContentHasBackground({ block, fullWidthLayout }: Props) {
  return (
    (blocksWithBackground.includes(block.type) ||
      (block.type === 'SPLIT_CONTENT' &&
        block.data.appearance === 'OVERLAPPING') ||
      (block.type === 'THREE_STEP_CTA' &&
        ['One', 'Two', 'Three'].some(
          (step) =>
            block.data[`step${step}Url`] && block.data.imageSize === 'SMALL'
        ))) &&
    fullWidthLayout
  );
}
